/**
 * @generated SignedSource<<436c7657ed8a5df7b99af5c620de47a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPostStatusEnum = "approved" | "draft" | "published";
export type UpdateBlogPostInput = {
  blogCategoryIds?: ReadonlyArray<string> | null | undefined;
  blogPostId?: string | null | undefined;
  blogPostRawId?: number | null | undefined;
  blogSubcategoryIds?: ReadonlyArray<string> | null | undefined;
  clientMutationId?: string | null | undefined;
  content?: string | null | undefined;
  excerpt?: string | null | undefined;
  published?: boolean | null | undefined;
  title?: string | null | undefined;
  videoId?: string | null | undefined;
  videoRawId?: number | null | undefined;
};
export type BlogPostListItem_UpdateMutation$variables = {
  input: UpdateBlogPostInput;
};
export type BlogPostListItem_UpdateMutation$data = {
  readonly updateBlogPost: {
    readonly blogPost: {
      readonly status: BlogPostStatusEnum | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"BlogPostListItem_BlogPost">;
    } | null | undefined;
  } | null | undefined;
};
export type BlogPostListItem_UpdateMutation = {
  response: BlogPostListItem_UpdateMutation$data;
  variables: BlogPostListItem_UpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogPostListItem_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBlogPostPayload",
        "kind": "LinkedField",
        "name": "updateBlogPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPost",
            "kind": "LinkedField",
            "name": "blogPost",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BlogPostListItem_BlogPost"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogPostListItem_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBlogPostPayload",
        "kind": "LinkedField",
        "name": "updateBlogPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogPost",
            "kind": "LinkedField",
            "name": "blogPost",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BlogCategory",
                "kind": "LinkedField",
                "name": "blogCategories",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedReadingTimeMinutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewsCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91cad370d1307924467d5773179cffb5",
    "id": null,
    "metadata": {},
    "name": "BlogPostListItem_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BlogPostListItem_UpdateMutation(\n  $input: UpdateBlogPostInput!\n) {\n  updateBlogPost(input: $input) {\n    blogPost {\n      status\n      ...BlogPostListItem_BlogPost\n      id\n    }\n  }\n}\n\nfragment BlogPostItem_BlogPost on BlogPost {\n  title\n  excerpt\n  slug\n  blogCategories {\n    name\n    slug\n    id\n  }\n  createdAt\n  estimatedReadingTimeMinutes\n  viewsCount\n  user {\n    name\n    profile {\n      slug\n      id\n    }\n    ...UserAvatarContainer_User\n    id\n  }\n}\n\nfragment BlogPostListItem_BlogPost on BlogPost {\n  status\n  excerpt\n  slug\n  id\n  user {\n    profile {\n      slug\n      id\n    }\n    id\n  }\n  ...BlogPostItem_BlogPost\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n"
  }
};
})();

(node as any).hash = "f1f9588f72737f31f886fa430a7b959c";

export default node;
